import moment from 'moment';

export default function TitanDateTime({
  time,
  format = 'YYYY-MM-DD HH:mm:ss',
  emptyValue = ''
}) {
  return time ? moment(time).format(format) : emptyValue;
}
